import type { JSX } from "preact";
import { useEffect, useState } from "preact/hooks";
import { Link } from "wouter-preact";
import { resultsPaths as paths } from "@gss/common/Paths";
import { Download, ListColumns } from "@gss/components/icons";
import { MeasurementFilter } from "@gss/components/MeasurementFilter";
import { useMessages } from "@gss/components/Messages";
import { Table, TableHeader } from "@gss/components/Table";
import type { VirtualMeasurement } from "@gss/types/VirtualMeasurement";
import { DAO } from "../DAO";
import { Back } from "../util/Back";

export function Exports(): JSX.Element | null {
    const [measurements, setMeasurements] = useState<VirtualMeasurement[]>();
    const { addError } = useMessages();

    useEffect(() => {
        DAO.export.getMeasurements().then(setMeasurements).catch(addError);
    }, []);

    if (measurements == null) {
        return null;
    }

    return (
        <div>
            <Back />

            <h1>Exportera resultat</h1>

            <MeasurementFilter
                sortOrder="name-period"
                measurements={measurements}
                render={renderTable}
            />
        </div>
    );
}

function renderTable(filteredMeasurements: VirtualMeasurement[]): JSX.Element {
    return (
        <>
            <TableHeader list={filteredMeasurements}>Mätningar</TableHeader>
            <Table
                striped
                headers={
                    <tr>
                        <th>Verksamhetsområde</th>
                        <th>Period</th>
                        <th>Export</th>
                        <th>Summering</th>
                    </tr>
                }
            >
                {filteredMeasurements.map((m) => (
                    <tr key={m.name + m.period}>
                        <td>{m.name}</td>
                        <td>{m.period}</td>
                        <td>
                            <Link href={paths.getExportPath(m.name, m.period)}>
                                <Download />
                            </Link>
                        </td>
                        <td>
                            <Link href={paths.getSummaryPath(m.name, m.period)}>
                                <ListColumns />
                            </Link>
                        </td>
                    </tr>
                ))}
            </Table>
        </>
    );
}
